var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchInput',{attrs:{"placeholder":"Search for assets","value":_vm.searchTerm,"filters-applied":_vm.areFiltersApplied,"include-filters":""},on:{"changeValue":_vm.setSearchTerm,"openFilters":_vm.openFilters,"clear":_vm.onClearSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }